package com.parmartechnologies.core.feature.businessType.network

import kotlinx.datetime.LocalDateTime
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.time.Clock
import kotlin.time.ExperimentalTime

@Serializable
data class BusinessTypeRequest(
    @SerialName("business_id") val BusinessID: String,
)
@Serializable
data class CreateBusinessTypeRequest @OptIn(ExperimentalTime::class) constructor(
    @SerialName("name") var name: String = "",
    @SerialName("description") var description: String = "",
    @SerialName("image") var image: ArrayList<String> = arrayListOf(),
    @SerialName("business_type_id") var business_type_id: Int = 0,
    @SerialName("created_at") val created_at: LocalDateTime = Clock.System.now().toLocalDateTime(
        TimeZone.UTC),
    @SerialName("updated_at") val updated_at: LocalDateTime = Clock.System.now().toLocalDateTime(
        TimeZone.UTC),
    @SerialName("__v") var _v: Int = 0
)